// extracted by mini-css-extract-plugin
export default {"container":"CoreAbilities_container__y-esQ box_box__N+eYm","heading":"CoreAbilities_heading__RnPrF heading_heading1__qV9TO heading_heading__obBAB"};